import React, { useEffect, useState } from 'react'
import { Card } from 'react-bootstrap'
import { MessageError, MessageSuccess } from '../../../../Student/Profiles/components/ProfileUI';
import { openModal } from '../../../../../Library/ModalPopUp';
import { handleKeyDown, validateCellular, validateName } from '../../../../Student/Profiles/_core/_core';
import { EncodeURIComponentSafe } from '../../../../../Library/GlobalHelper';
import { UPDATE_CANDIDATE } from '../../../../Student/Profiles/API';
import { SelectInputProfession } from '../../../../Student/Profiles/_core/SelectInput';

export function FormParents({ data }) {
    const [errors, setErrors] = useState({});
    const [fm_type, setFmType] = useState(data?.fm_type || "");
    const [parent_name, setParent_name] = useState(data?.parent_name || "");
    const [parent_phone, setparent_phone] = useState(data?.parent_phone || "");
    const [parent_email, setparent_email] = useState(data?.parent_email || "");
    const [parent_profession, setparent_profession] = useState(data?.parent_profession || "");
    const [parent_profession_oth, setparent_ProfessionOth] = useState(
        data?.parent_profession_other || ""
    );

    const validateForm = () => {
        let newErrors = {};

        const parent_nameError = validateName(parent_name);
        if (parent_nameError) newErrors.parent_name = parent_nameError;
        if (!parent_email) newErrors.parent_email = "Email is required";
        if (!parent_profession) newErrors.parent_profession = "Profession is required";
        const parent_phoneError = validateCellular(parent_phone);
        if (parent_phoneError) newErrors.parent_phone = parent_phoneError;

        setErrors(newErrors);
    };

    useEffect(() => {
        validateForm();
    }, [fm_type, parent_name, parent_email, parent_phone, parent_profession]);

    const [submit, setSubmit] = useState({
        loading: false,
        data: [],
        message: "",
    });
    const SubmitHandler = async (e) => {
        e.preventDefault();
        if (Object.keys(errors).length === 0) {
            setSubmit({ loading: true, message: "", data: [] });
            const param_enrollment = {
                id: data?.id,
                fm_type:EncodeURIComponentSafe(fm_type),
                parent_name: EncodeURIComponentSafe(parent_name),
                parent_email,
                parent_phone,
                parent_profession_id: parent_profession,
                parent_profession_oth:parent_profession_oth ? EncodeURIComponentSafe(parent_profession_oth) : ""
            }
            try {
                const results = await UPDATE_CANDIDATE(param_enrollment);
                if (results.data && Object.values(results.data).length > 0) {
                    openModal({
                        message: <MessageSuccess message={"Successfully saved"} />,
                    });
                    // ReloadDataStd();
                } else {
                    openModal({
                        message: (
                            <MessageError message={results.message} title="Failed Save" />
                        ),
                    });
                }
                setSubmit(results);
            } catch (error) {
                setSubmit({ loading: false, message: error?.message, data: [] });
                openModal({
                    message: (
                        <MessageError message={error?.message} />
                    ),
                });
            }
        } else {
            openModal({
                message: (
                    <MessageError
                        message={
                            "Please verify your input and ensure it is completed correctly."
                        }
                    />
                ),
            });
            setSubmit({ loading: false, message: "", data: [] });
        }
    }
    return (
        <Card>
            <Card.Body>
                <form method="post" autoComplete="off" onSubmit={(e) => SubmitHandler(e)}>
                    <div className="row mb-8">
                        <label className="col-lg-4 col-form-label required font-weight-semibold h6">
                            Type <sup className="text-danger">*</sup>
                        </label>
                        <div className="col-lg-8">
                            <select name="fm_type" className="form-control form-control-lg form-control-solid" value={fm_type} onChange={(e) => setFmType(e.target.value)}>
                                <option value="">Choose One</option>
                                <option value="FATHER">Father</option>
                                <option value="MOTHER">Mother</option>
                            </select>
                            {errors.fm_type && <div className="text-danger">{errors.fm_type}</div>}
                        </div>
                    </div>
                    <div className="row mb-8">
                        <label className="col-lg-4 col-form-label required font-weight-semibold h6">
                            Fullname <sup className="text-danger">*</sup>
                        </label>
                        <div className="col-lg-8">
                            <input type="text" className="form-control form-control-lg form-control-solid" value={parent_name} onChange={(e) => setParent_name(e.target.value)} />
                            {errors.parent_name && <div className="text-danger">{errors.parent_name}</div>}
                        </div>
                    </div>
                    <div className="row mb-8">
                        <label className="col-lg-4 col-form-label required font-weight-semibold h6">
                            Profession
                            <sup className="text-danger">*</sup>
                        </label>
                        <div className="col-lg-8">
                            <SelectInputProfession
                                data={parent_profession}
                                setData={setparent_profession}
                                data_oth={parent_profession_oth}
                                setOth={setparent_ProfessionOth}
                                isSolid={true}
                            />
                            {errors.parent_profession && (
                                <div className="text-danger">{errors.parent_profession}</div>
                            )}
                        </div>
                    </div>
                    <div className="row mb-8">
                        <label className="col-lg-4 col-form-label required font-weight-semibold h6">
                            Cellular Number <sup className="text-danger">*</sup>
                        </label>
                        <div className="col-lg-8">
                            <input type="text" className="form-control form-control-lg form-control-solid"
                                value={parent_phone}
                                onKeyDown={handleKeyDown}
                                onInput={(e) => {
                                    const value = e.target.value.replace(/\D/g, "");
                                    setparent_phone(value);
                                }} />
                            {errors.parent_phone && <div className="text-danger">{errors.parent_phone}</div>}
                        </div>
                    </div>
                    <div className="row mb-8">
                        <label className="col-lg-4 col-form-label required font-weight-semibold h6">
                            Email <sup className="text-danger">*</sup>
                        </label>
                        <div className="col-lg-8">
                            <input type="text" className="form-control form-control-lg form-control-solid" value={parent_email} onChange={(e) => setparent_email(e.target.value)} />
                            {errors.parent_email && <div className="text-danger">{errors.parent_email}</div>}
                        </div>
                    </div>

                    <div className="text-right mt-8">
                        <button
                            className="btn btn-lg btn-primary mr-3"
                            type="submit"
                            disabled={submit.loading}
                        >
                            {submit.loading ? "Processing..." : "Save Changes"}
                        </button>
                    </div>
                </form>
            </Card.Body>
        </Card>
    )
}
